import Estimate, { showEstimate } from "src/module/estimate/estimate";
// import style from "./addEstimateResult.css";

const kzs = window.kzs;
const $ = kzs.$;

export const addEstimateResult = (): void => {
  console.log("variations/addEstimateResult");

  // style.use();

  showEstimate(Estimate);
};
